import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { FileText, Inbox, Eye, XCircle, Plus, MapPin } from "lucide-react";

const STATUS = {
  pending_pro: "Recherche en cours", distributed: "Transmise", closed: "Clôturée", suspended: "Suspendue", realized: "Travaux réalisés",
};

export default function MyQuotes() {
  const [items, setItems] = useState(null);

  const load = () => api.get("/devis/me/requests").then((r) => setItems(r.data.items || [])).catch((e) => { toast.error(formatApiError(e)); setItems([]); });
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const close = async (id) => {
    try { await api.post(`/devis/requests/${id}/close`); toast.success("Demande clôturée."); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div data-testid="my-quotes-page">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <h1 className="font-heading text-2xl font-extrabold text-[#172A3A] flex items-center gap-2"><FileText size={22} className="text-[#E05638]" /> Mes demandes de devis</h1>
        <Link to="/demande-de-devis" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-bold text-white bg-[#E05638] hover:bg-[#c7482d]" data-testid="my-quotes-new"><Plus size={15} /> Nouvelle demande</Link>
      </div>
      {items === null ? <div className="p-10 text-center text-slate-400">Chargement…</div>
        : items.length === 0 ? (
          <div className="bg-white rounded-2xl border border-slate-100 p-10 text-center" data-testid="my-quotes-empty">
            <Inbox size={36} className="text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500">Vous n'avez pas encore de demande. <Link to="/demande-de-devis" className="text-[#E05638] font-semibold">Demandez un devis gratuit</Link>.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {items.map((r) => (
              <div key={r.id} className="bg-white rounded-2xl border border-slate-100 p-5" data-testid="my-quote-card">
                <div className="flex items-start justify-between flex-wrap gap-2">
                  <div>
                    <div className="font-heading text-lg font-bold text-[#172A3A]">{r.trade_name}{r.subneed ? ` · ${r.subneed}` : ""}</div>
                    <div className="flex items-center gap-3 text-sm text-slate-500 mt-0.5"><span className="inline-flex items-center gap-1"><MapPin size={13} /> {r.city}</span><span className="text-xs text-slate-400">{r.ref}</span></div>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-slate-100 text-slate-600">{STATUS[r.status] || r.status}</span>
                </div>
                <p className="mt-2 text-sm text-slate-600 line-clamp-2">{r.description}</p>
                <div className="mt-3 flex items-center gap-4 text-sm">
                  <span className="text-slate-500">{r.responses_count} réponse{r.responses_count > 1 ? "s" : ""} · {r.assigned_count} pro{r.assigned_count > 1 ? "s" : ""} contacté{r.assigned_count > 1 ? "s" : ""}</span>
                  <Link to={`/suivi-devis/${r.track_token}`} className="inline-flex items-center gap-1 text-[#E05638] font-semibold" data-testid="my-quote-view"><Eye size={14} /> Suivre</Link>
                  {r.status !== "closed" && <button onClick={() => close(r.id)} className="inline-flex items-center gap-1 text-slate-400 hover:text-red-600" data-testid="my-quote-close"><XCircle size={14} /> Clôturer</button>}
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
